const $inject = ['$window', 'locationsSearchService'];

const lbPoiSelectCtrl = function ($window, locationsSearchService) {
  let vm = this;

  const MIN_SEARCH_TEXT_LENGTH = 2;
  const MAX_SEARCH_RESULTS = 10;
  const REFRESH_DELAY = 500;
  const placeholderText = vm.placeholderText || 'Destination, airport, train station, landmark or hotel';

  vm.allowClear = true;
  vm.required = vm.required || false;
  vm.placeholder = vm.disablePlaceholder ? '' : placeholderText;
  vm.iconClassName = vm.iconClassName || 'ico-marker';
  vm.options = [];
  vm.defaultOptions = vm.defaultOptions || [];
  vm.showLoader = false;
  vm.refreshDelay = REFRESH_DELAY;

  vm.refreshOptions = refreshOptions;
  vm.onRemove = onRemove;
  vm.onSelect = onSelect;

  vm.defaultOptions = _.orderBy(_.map(vm.defaultOptions, (location) => {
    return {
      Title: location.HotelName,
      Latitude: location.Latitude,
      Longitude: location.Longitude
    };
  }), 'Title');

  vm.options = _.clone(vm.defaultOptions);

  function refreshOptions(search) {
    vm.currentSearch = search;

    if(search.length <= MIN_SEARCH_TEXT_LENGTH) {
      return vm.defaultOptions;
    }

    vm.showLoader = true;

    return locationsSearchService.get({
      maxRows: MAX_SEARCH_RESULTS,
      term: search
    })

    .then((result) => {
      vm.options = result;
    })

    .finally(() => {
      vm.showLoader = false;
    });
  }

  function onRemove() {
    vm.options = _.clone(vm.defaultOptions);
  }

  function onSelect() {
    if (!vm.location) return;
    window.svelteStore.track('POI_SEARCH_ITEM_SELECTED', {
      'searchText': vm.currentSearch,
      'itemTitle': vm.location.Title,
      'itemIndex': vm.options.indexOf(vm.location) + 1,
      'itemSearchScore': vm.location.SearchScore,
      'itemType': vm.location.Type
    });
  }
};

lbPoiSelectCtrl.$inject = $inject;

export default lbPoiSelectCtrl;



// WEBPACK FOOTER //
// ./src/components/lbPoiSelect/lbPoiSelectCtrl.js